import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b494f5c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rel wash-item flex-center of-hd" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "abs-wrap",
  style: {"background":"rgba(0, 0, 0, 0.23)"}
}, null, -1))
const _hoisted_3 = ["onClick"]

import WashingMarkContent from './WashingMarkContent.vue'
import { ref, watch, onMounted } from 'vue'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import $ from 'jquery'


export default /*#__PURE__*/_defineComponent({
  props: {
    washData: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as { washData: any }


const urlList: any = ref([])
const washMark: any = ref({})
const skuType: any = ref()
const imageRatio = ref(0)
const isRotate = ref(false)
const editStatus = ref({})

watch(() => props.washData, (item = {}) => {
  washMark.value = item
  urlList.value = item.companyLogo ? [item.companyLogo] : []
  skuType.value = item.productDesignation
  if (item.imageRatio) {
    imageRatio.value = item.imageRatio
  }
}, { immediate: true })

const visible = ref(false)
const container1 = ref()
const container2 = ref()
const node = ref()

const zoom = () => {
  visible.value = true
  setTimeout(() => {
    $(container2.value).children().remove()
    container2.value.appendChild($.clone(node.value.$el))
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "rel preview",
      ref: (_value, _refs) => {
        _refs['container1'] = _value
        container1.value = _value
      },
      style: {"transform":"scale(0.1)"}
    }, [
      _createVNode(WashingMarkContent, {
        isRotate: isRotate.value,
        "sku-type": skuType.value,
        "edit-status": editStatus.value,
        washMark: washMark.value,
        imageRatio: imageRatio.value,
        urlList: urlList.value,
        isPreview: true,
        ref: (_value, _refs) => {
          _refs['node'] = _value
          node.value = _value
        }
      }, null, 8, ["isRotate", "sku-type", "edit-status", "washMark", "imageRatio", "urlList"])
    ], 512),
    _hoisted_2,
    _createElementVNode("div", {
      class: "abs zoom",
      style: {"bottom":"4px","right":"4px","cursor":"pointer","background":"rgba(0,0,0,20%)","border-radius":"50%"},
      onClick: _withModifiers(zoom, ["stop"])
    }, [
      _createVNode(SvgIcon, {
        class: "wrap rel",
        name: "放大2",
        style: {"z-index":"1","font-size":"20px"}
      })
    ], 8, _hoisted_3),
    _createVNode(_component_el_dialog, {
      "append-to-body": true,
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      top: "5vh",
      draggable: true,
      "show-close": false,
      "custom-class": "wash-dialog",
      width: 300
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          ref: (_value, _refs) => {
            _refs['container2'] = _value
            container2.value = _value
          },
          class: "flex-center",
          style: {"pointer-events":"none"}
        }, null, 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})